import Vue from 'vue'
import Router from 'vue-router'
import Toasted from 'vue-toasted'

// Containers
import Blank from '@/containers/Blank'
import User from '@/containers/User'
import Basic from '@/containers/Basic'

// Views
import ContactView from '@/views/contact/view'
import ContactAdd from '@/views/contact/add'
import ContactEdit from '@/views/contact/edit'
import RFQView from '@/views/rfq/view'
import RFQEdit from '@/views/rfq/edit'
import RFQDetail from '@/views/rfq/detail'
import RFQFinish from '@/views/rfq/finish'
import MapPage from '@/views/map/MapPage.vue'
import RFQTesting from '@/views/testing/RFQTesting.vue'

import DashboardView from '@/views/dashboard/DashboardView'

import InventoryView from '@/views/inventory/view'
import InventoryAdd from '@/views/inventory/add'
import InventoryEdit from '@/views/inventory/edit'

// import ShipmentDetail from '@/views/shipment/detail'
import AssetView from '@/views/asset/AssetView'
import AssetAdd from '@/views/asset/AssetAdd'
import AssetEdit from '@/views/asset/AssetEdit'
import AssetDetails from '@/views/asset/AssetDetails'

import ShipmentView from '@/views/shipment/ShipmentView'
import ShipmentDetail from '@/views/shipment/ShipmentDetail'
import ShipmentTracking from '@/views/shipment/ShipmentTracking'

import AuthLogin from '@/views/auth/login'
import AuthSignup from '@/views/auth/signup'
import Demo from '@/views/auth/demo'

import t_dashboard from '@/views/raw_templates/t_dashboard'
import t_createrfq from '@/views/raw_templates/t_createrfq'
import t_viewrfq from '@/views/raw_templates/t_viewrfq'
import t_contacts from '@/views/raw_templates/t_contacts'
import t_add_contacts from '@/views/raw_templates/t_add_contacts'
import t_login from '@/views/raw_templates/t_login'
import t_assets from '@/views/raw_templates/t_assets'
import t_assets_addedit from '@/views/raw_templates/t_assets_addedit'

import { authGuard } from './auth-guard';

Vue.use(Router)
Vue.use(Toasted)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [

    {
      path: '/signup',
      name: 'Signup',
      component: Basic,
      children: [
        {
          path: '/signup',
          name: 'Signup',
          component: AuthSignup
        }
      ]
    },

    {
      path: '/',
      redirect: '/rfq/view',
      name: 'Home',
      component: User,
      beforeEnter: authGuard,
    },

    {
      path: '/contact/view',
      redirect: '/contact/view',
      name: 'Contacts',
      component: User,
      beforeEnter: authGuard,
      children: [
        {
          path: '/contact/view',
          name: 'View Contacts',
          component: ContactView
        },
        {
          path: '/contact/add',
          name: 'Add Contact',
          component: ContactAdd
        },
        {
          path: '/contact/edit',
          name: 'Edit Contact',
          component: ContactEdit
        }
      ]
    },
    {
      path: '/map',
      name: 'MapPage',
      component: User,
      beforeEnter: authGuard,
      children: [
        {
          path: '/map/',
          name: 'Map View',
          component: MapPage
        },
      ]
    },
    {
      path: '/testing',
      name: 'RFQTesting',
      component: User,
      beforeEnter: authGuard,
      children: [
        {
          path: '/testing/rfq/',
          name: 'RFQ Testing',
          component: RFQTesting,
        },
      ]
    },
    {
      path: '/rfq',
      redirect: '/rfq/view',
      name: 'RFQs',
      component: User,
      beforeEnter: authGuard,
      children: [
        {
          path: '/rfq/view',
          name: 'View RFQs',
          component: RFQView
        },
        {
          path: '/rfq/view/:id',
          name: 'RFQ Detail',
          component: RFQDetail
        },
        {
          path: '/rfq/edit/:id',
          name: 'RFQ Edit',
          component: RFQEdit
        },
        {
          path: '/rfq/edit',
          name: 'RFQ Create',
          component: RFQEdit
        },
        {
          path: '/rfq/finish/:id/:entity',
          name: 'Finish RFQ',
          component: RFQFinish
        }
      ]
    },
    {
      path: '/asset',
      redirect: '/asset/view',
      name: 'Assets',
      component: User,
      beforeEnter: authGuard,
      children: [
        {
          path: '/asset/view',
          name: 'View Assets',
          component: AssetView
        },
        {
          path: '/asset/:type/add',
          name: 'Add Asset',
          component: AssetAdd
        },
        {
          path: '/asset/:type/edit/:id',
          name: 'Edit Asset',
          component: AssetEdit
        },
        {
          path: '/asset/:type/details/:id',
          name: 'Asset Details',
          component: AssetDetails
        },
      ]
    },
    {
      path: '/inventory',
      redirect: '/inventory/view',
      name: 'Inventory',
      component: User,
      beforeEnter: authGuard,
      children: [
        {
          path: '/inventory/view',
          name: 'View Inventory',
          component: InventoryView
        },
        {
          path: '/inventory/add',
          name: 'Add Inventory',
          component: InventoryAdd
        },
        {
          path: '/inventory/edit/:id',
          name: 'Edit Inventory',
          component: InventoryEdit
        }
      ]
    },
    {
      path: '/shipment',
      redirect: '/shipment/view',
      name: 'Shipments',
      component: User,
      beforeEnter: authGuard,
      children: [
        {
          path: '/shipment/view',
          name: 'View Shipments',
          component: ShipmentView
        },
        {
          path: '/shipment/view/:id',
          name: 'Shipment Detail',
          component: ShipmentDetail
        },
        {
          path: '/shipment/tracking/:id',
          name: 'Shipment Tracking',
          component: ShipmentTracking
        },
      ]
    },
    {
        path: '/dashboard',
        redirect: '/dashboard/view',
        name: 'Dashboard',
        component: User,
        beforeEnter: authGuard,
        children: [
          {
            path: '/dashboard/view',
            name: 'View Dashboard',
            component: DashboardView
          },
        ]
      },
    {
      path: '/',
      redirect: '/auth/login',
      name: 'Auth',
      component: Basic,
      children: [
        {
          path: '/auth/login',
          name: 'Login',
          component: AuthLogin
        }
      ]
    },
    {
      path: '/demo',
      redirect: '/auth/demo',
      name: 'Demo',
      component: Blank,
      children: [
        {
          path: '/auth/demo',
          name: 'Demo',
          component: Demo
        }
      ]
    },
    {
      path: '/t_dashboard',
      redirect: '/raw_templates/t_dashboard',
      name: 'Dashboard Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_dashboard',
          name: 'Dashboard Template',
          component: t_dashboard
        }
      ]
    },
    {
      path: '/t_createrfq',
      redirect: '/raw_templates/t_createrfq',
      name: 'Create RFQ Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_createrfq',
          name: 'Create RFQ Template',
          component: t_createrfq
        }
      ]
    },
    {
      path: '/t_viewrfq',
      redirect: '/raw_templates/t_viewrfq',
      name: 'View RFQ Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_viewrfq',
          name: 'View RFQ Template',
          component: t_viewrfq
        }
      ]
    },
    {
      path: '/t_contacts',
      redirect: '/raw_templates/t_contacts',
      name: 'View Contacts Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_contacts',
          name: 'View Contacts Template',
          component: t_contacts
        }
      ]
    },
    {
      path: '/t_add_contacts',
      redirect: '/raw_templates/t_add_contacts',
      name: 'Add Contacts Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_add_contacts',
          name: 'Add Contacts Template',
          component: t_add_contacts
        }
      ]
    },
    {
      path: '/t_login',
      redirect: '/raw_templates/t_login',
      name: 'Login Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_login',
          name: 'Login Template',
          component: t_login
        }
      ]
    },
    {
      path: '/t_assets',
      redirect: '/raw_templates/t_assets',
      name: 'Assets Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_assets',
          name: 'Assets Template',
          component: t_assets
        }
      ]
    },
    {
      path: '/t_assets_addedit',
      redirect: '/raw_templates/t_assets_addedit',
      name: 'Assets Add Edit Template',
      component: Blank,
      children: [
        {
          path: '/raw_templates/t_assets_addedit',
          name: 'Assets Add Edit Template',
          component: t_assets_addedit
        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js